import React from 'react';
import { useParams } from 'react-router-dom';

import { createFormName } from '@/utility/createFormName';
import { kebabToCamelCase } from '@/utility/kebabToCamelCase';

export const useStepperFormName = (): string | undefined => {
  const { parentId, childId } = useParams();

  return React.useMemo(
    (): string | undefined =>
      parentId && childId
        ? createFormName(kebabToCamelCase(parentId), kebabToCamelCase(childId))
        : undefined,
    [parentId, childId],
  );
};
